export default __webpack_public_path__ + "static/media/home-banner.47d23d02.jpg";